import { createHttpClient } from '@wix/http-client';
import { joinURL } from '../helpers';
import { createEditorPlatformWorkerError, EditorPlatformWorkerErrorCode } from '../errors';
const WORKER_ARTIFACT_ID = 'editor-platform-host-integration';
const WORKER_SCRIPT_NAME = 'editor-platform-worker.umd.js';
const httpClient = createHttpClient();
const getBaseUrl = function (workerScriptBaseUrl, scriptsDomainUrl, baseDomain) {
  const urlToReplace = joinURL(scriptsDomainUrl, 'services').replace(/\/+$/, '');
  return workerScriptBaseUrl.replace(urlToReplace, baseDomain.replace(/\/+$/, ''));
};
function isLocalWorker(urlBase) {
  const localhostRegex = /^https?:\/\/localhost($|:|\/)/;
  return localhostRegex.test(urlBase) ? urlBase : null;
}
export async function getWorkerUrl() {
  // TODO: get service topology from the DM or HostAPI
  // Jira task: https://jira.wixpress.com/browse/EP-3787

  // @ts-expect-error xxx
  const serviceTopology = window.serviceTopology;
  const workerScriptBaseUrl = serviceTopology.scriptsLocationMap[WORKER_ARTIFACT_ID];
  const baseDomain = serviceTopology.editorWorkerBaseUrl;
  const {
    scriptsDomainUrl
  } = serviceTopology;
  const baseUrl = getBaseUrl(workerScriptBaseUrl, scriptsDomainUrl, baseDomain);
  if (isLocalWorker(baseUrl)) {
    try {
      const remoteUrl = `${baseUrl}/${WORKER_SCRIPT_NAME}`;
      const response = await httpClient.get(remoteUrl);
      const bundle = response.data;
      return URL.createObjectURL(new Blob([bundle], {
        type: 'application/javascript'
      }));
    } catch (e) {
      throw createEditorPlatformWorkerError(EditorPlatformWorkerErrorCode.WorkerFetchError).withParentError(e);
    }
  }
  return joinURL(baseUrl, WORKER_SCRIPT_NAME);
}
//# sourceMappingURL=getWorkerUrl.js.map